<div class="card">
    <div class="card-body" >
        <form [formGroup]="projectForm" novalidate>
            <!-- <mat-form-field style="width: 0;"> -->
                <input matInput hidden formControlName="id">
            <!-- </mat-form-field> -->

            <div class="row">
                <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput type="text" placeholder="{{this.translate.data['INPUTPROJECTNAME'] | translate}}" formControlName="display_name" readonly>
                    </mat-form-field>
                </div>
                <!-- <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput type="text" placeholder="{{this.translate.data['INPUTPROJECTNAME'] | translate}}" formControlName="name" readonly>
                    </mat-form-field>
                </div> -->
                <!-- <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput type="text" placeholder="{{this.translate.data['INPUTPROJECTURL'] | translate}}" formControlName="url">
                    </mat-form-field> -->
                <!-- </div> -->
                <!-- <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput type="number" placeholder="{{this.translate.data['LATITUDE'] | translate}}" formControlName="latitude">
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field class="example-full-width">
                        <input matInput type="number" placeholder="{{this.translate.data['LONGITUDE'] | translate}}" formControlName="longitude">
                    </mat-form-field>
                </div> -->
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <textarea matInput placeholder="{{this.translate.data['TEXTAREADESCRIPTION'] | translate}}" formControlName="description"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <mat-label>{{this.translate.data['SELECTCONTROLSELECTCOLOR'] | translate}}</mat-label>
                        <mat-select formControlName="color">
                            <mat-option *ngFor="let item of listColors" [value]="item">
                                {{item}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->

            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
            (click)="cancel()" >Abbruch</button>
            <!-- <span style="flex: 1 1 auto"></span> -->
            <button mat-raised-button type="submit" class="btn btn-squirrel pull-right"
                (click)="editProjectInfo()">{{this.translate.data['MODIFY'] | translate}}</button>
            <div class="clearfix"></div>
        </form>
    </div>
</div>